module.exports = __webpack_public_path__ + "img/tcb-full-logo.a5f41e7e.png";